import * as React from "react"
import {
  SelectConnectedField,
  SelectConnectedFieldProps,
} from "gatsby-interface"
import { useVercelTeamsForSiteQuery } from "@modules/cdn/vercel/queries.generated"
import { vercelIntegrationConfig as text } from "@modules/locales/default.json"
import { PERSONAL_TEAM_ID } from "../utils"

export type VercelTeamFieldProps = Omit<
  SelectConnectedFieldProps,
  "options"
> & {
  siteId: string
}

export function VercelTeamField({ siteId, ...rest }: VercelTeamFieldProps) {
  const { data, loading } = useVercelTeamsForSiteQuery({
    variables: {
      siteId,
    },
    fetchPolicy: `cache-and-network`,
  })

  const teams = data?.nowTeamsForGatsbySiteId ?? []

  const teamOptions = React.useMemo<
    SelectConnectedFieldProps["options"]
  >(() => {
    return [
      { value: PERSONAL_TEAM_ID, label: text.labels.teamPersonalLabel },
    ].concat(
      teams.map(({ slug, name }) => ({
        value: slug,
        label: name,
      }))
    )
  }, [teams])

  return (
    <SelectConnectedField options={teamOptions} disabled={loading} {...rest} />
  )
}
